/* RESPONSIBLE TEAM: team-messenger */

import Model, { attr } from '@ember-data/model';
import { type Block } from '@intercom/interblocks.ts';

export default class Nudge extends Model {
  @attr() declare blocks: Array<Block>;
}
